<template>
    <el-drawer
        title="汇率设置"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                v-if="detail"
                :model="formData"
                :rules="rules"
                label-position="top"
                ref="formData"
            >
                <el-form-item prop="rate" label="最新汇率:">
                    1CNY = 
                    <el-input
                        v-model="formData.rate"
                        placeholder="请输入汇率"
                        type="number"
                        class="number"
                        size="medium"
                    ></el-input>
                    {{detail.code}}
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >提交</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    id: "",
    rate: ""
}
export default {
    data() {
        return {
            drawerShow: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules: {
                rate: [{ required: true, message: "请输入汇率" }],
            },
            detail:null
        };
    },
    methods: {
        close() {
            this.formData = {...defaultFormData};
            this.detail =null;
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(data) {
            this.detail = data;
            this.formData = {...this.detail};
            this.drawerShow = true;
        },
        //表单提交
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                    const _url = '/exchangeRate/edit'
                    this.btnLoading = true;

                    this.$request({
                        url: _url,
                        data: this.formData,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('update');
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.number{
    width: 200px;
}
</style>